// src/sim/ai/awareness/constants.ts — P4 awareness accumulator tunables (D-09).
// Tick-based at 30 Hz; accumulate at 10 Hz (per perception tick). TODO(P7 POL-06): retune.
//
// Source: .planning/phases/04-ai/04-CONTEXT.md D-09; 04-RESEARCH.md Pattern 2.

export const P4_AWARENESS_SUSPICIOUS = 0.25;
export const P4_AWARENESS_ALERTED = 0.55;
export const P4_AWARENESS_SPOTTED = 0.85;
export const P4_AWARENESS_BASE_RATE = 0.22;       // per perception tick (10 Hz) — 2026-06-12 hunter-spotting tuning (was 0.15: ~0.57s to spot; now ~0.4s) TODO(P7 POL-06)
export const P4_AWARENESS_DECAY_RATE = 0.05;       // per perception tick (Pitfall P4-H lock)
export const P4_AWARENESS_MAX_RANGE_TILES = 14;
export const P4_AWARENESS_STABILITY_TICKS = 2;     // D-10 (200 ms at 10 Hz)

export type AwarenessLevel = 'unaware' | 'suspicious' | 'alerted' | 'spotted';
